import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Card, CardBody, Container } from "reactstrap";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import { PopoverBody } from 'reactstrap';
import Select, { components } from "react-select";
import { get } from "lodash";
import { toast } from "react-toastify";

import PopoverFormula from '../../../../share-components/ui/PopoverFormula';
import BootstrapTable from "../../../../share-components/table/BootstrapTable";
import DateRangePickerPrimary from "../../../../share-components/ui/DateRangePickerPrimary";
import Breadcrumb from "../../../../layout/breadcrumb";

import withReducer from "../../../../store/withReducer";
import reportReducer from "../../index";

import {
    getShopifyPayouts,
    sendToXero,
} from "../store/payoutReportSlice";

import {
    formatterCurrency, formatterNumber
} from "../../../../utils/common";
import { getFinancesSummarySetting } from "../../financesSummary/store/financesSummarySlice";


const SendToXeroButton = ({ row, setTotalSTXRequests, setTotalSTXRequestsCompleted, disabled = false }) => {
    const dispatch = useDispatch();
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [disable, setDisable] = useState(disabled);
    
    const handleClick = () => {
        setLoadingBtn(true);
        setDisable(true);
        setTotalSTXRequests(prev => prev + 1);

        const params = { gateway: row.gateway, gateway_id: row.id };
        dispatch(sendToXero(params))
            .then((response) => {
                // Handle success
                console.log("Send successful", response);
            })
            .catch((error) => {
                // Handle error
                console.error("Send failed", error);
            })
            .finally(() => {
                setTotalSTXRequestsCompleted(prev => prev + 1);
                setLoadingBtn(false);
            });
    }

    return (
        <Button type="button" color="primary" size="xs" onClick={handleClick} disabled={disable ||loadingBtn}>
            {loadingBtn ? "Sending..." : "Send to Xero"}
        </Button>
    )
};

export function getGatewayURL(gateway, gatewayId, isGateway = true, partnerId = null, startDate, endDate) {

    const map = {
        paypal: "paypal",
        shopify: "shopify_payments",
        asos: "asos",
    };

    const key = gateway?.toLowerCase() || "";
    const finalGateway = map[key] || key; 

    let _startDate = moment(startDate).format("YYYY-MM-DD");
    let _endDate = moment(endDate).format("YYYY-MM-DD");

    return `/report/finances-summary/details-payments?is_date_wise_return=1&is_test_order=0&start_date=${_startDate}&end_date=${_endDate}&gateway=${finalGateway}${isGateway ? `&gateway_id=${gatewayId}` : `&partner=${partnerId}`}`;
}


const ShopifyPayout = (props) => {
    const financesSummaryState = useSelector(
        ({ report }) => report.financesSummary
    );

    const payoutReportState = useSelector(
        ({ report }) => report.payoutReport
    );

    const dispatch = useDispatch();
    const history = useHistory();
    const queryParams = new URLSearchParams(window.location.search);

    // helper to ensure a value is a valid date/moment/string parseable by moment
    const isValidDate = (d) => d !== undefined && moment(d).isValid();

    // read initial gateway from url
    const gatewayParam = queryParams.get('gateway') || null;

    const defaultGateway = gatewayParam ? { key: gatewayParam, name: '' } : null;

    // helper to update/replace URL params
    const updateUrlParams = (params) => {
        const url = new URL(window.location.href);
        Object.keys(params).forEach((k) => {
            const v = params[k];
            if (v !== null && v !== undefined && v !== "") url.searchParams.set(k, v);
            else url.searchParams.delete(k);
        });
        history.replace(url.pathname + url.search);
    };

    // parse query params and normalize invalid dates to undefined
    const _rawEnd = queryParams.has('end_date') ? new Date(queryParams.get('end_date')) : undefined;
    const _rawStart = queryParams.has('start_date') ? new Date(queryParams.get('start_date')) : undefined;
    const endDateObj = isValidDate(_rawEnd) ? _rawEnd : undefined;
    const startDateObj = isValidDate(_rawStart) ? _rawStart : undefined;

    // initialize dateRange with validated dates (undefined when absent/invalid)
    const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);
    const [startDate, endDate] = dateRange;
    const [gateway, setGateway] = useState(defaultGateway);
    const [partner, setPartner] = useState(null);

    // safe disabledDate: return false for falsy/invalid input
    const afterToday = () => {
        return (date) => {
            if (!isValidDate(date)) return false;
            return date.getTime() > Date.now();
        };
    };

    const [loading, setLoading] = useState(true);

    // per-row export loading state: { [invoiceId]: boolean }
    const [exportLoadingMap, setExportLoadingMap] = useState({});

    const [lastFilters, setLastFilters] = useState(null);
    const [filter, setFilter] = useState({
        page: 1,
        pageSize: 10,
        // set initial dates to null if not provided
        start_date: isValidDate(startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
        end_date: isValidDate(endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
        gateway : gatewayParam,
        partner_id : null,
        draw: 1,
    });
    
    // when financesSummary settings load, set gateway object if url contains gateway key
    useEffect(() => {
        const gateways = financesSummaryState?.settings?.gateways || [];
        if (gatewayParam && gateways.length > 0) {
            const found = gateways.find(g => g.key === gatewayParam);
            console.log('found gateway', found);
            if (found) setGateway(found);
        }
    }, [financesSummaryState.settings.gateways]);

    const dataMenu = [
        {
            type: 0,
            text: "Reports",
        },
        {
            type: 0,
            text: "Payments Sources",
        },
    ];

    useEffect(() => {
        dispatch(getFinancesSummarySetting());
    }, [dispatch]);

    const getReport = () => {
        if (JSON.stringify(filter) == JSON.stringify(lastFilters)) return;

        setLastFilters({ ...filter });
        setLoading(true);

        dispatch(
            getShopifyPayouts(filter)
        ).then((res) => {
            if (!res.error) {
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        getReport();
    }, [dispatch, filter]);

    const tableColumns = [
        {
            name: 'Payout Date',
            selector: row => {
                const url = getGatewayURL(row.gateway, row.id, row.isGateway, row.payout_id, row.start_date, row.end_date);

                return (
                    <Link 
                        to={url}
                        className="font-weight-bold text-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {moment(row.payout_date).format("DD-MMM-YYYY")}
                    </Link>
                );
            },
            left: true,
        },
        {
            name: 'Transaction Date',
            selector: row => row.transaction_date,
            center: true,
        },
        {
            name: 'Partner',
            selector: row => row.partner_name,
            center: true,
        },
        {
            name: 'Gateway',
            selector: row => row.gateway_name,
            center: true,
        },
        {
            name: 'Transaction ID',
            selector: row => row.payout_id,
            left: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            center: true,
        },
        {
            name: 'Currency',
            selector: row => row.currency_code,
            center: true,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            right: true,
        },
        {
            name: `${partner ? 'Commision' : 'Charge Fee'}`,
            selector: row => row.charge_fee,
            right: true,
        },
        {
            name: 'Net Amount',
            selector: row => row.net_amount,
            right: true,
        },
        {
            name: 'Xero Payment Status',
            selector: row => (
                <>
                    <span className={`badge badge-${row.xero_payment_status === 'Paid' ? 'success' : 'warning'}`}>
                        {row.xero_payment_status}
                    </span>
                </>
            ),
            center: true,
        },
        {
            name: 'Actions',
            selector: row => (
                <SendToXeroButton
                    disabled={row.xero_payment_status === 'Paid'}
                    row={row}
                    setTotalSTXRequests={setTotalSTXRequests}
                    setTotalSTXRequestsCompleted={setTotalSTXRequestsCompleted} />
            ),
            right: true,
        },
    ];

    const onPageSizeChange = (newPageSize) => {
        setFilter(prev => ({
            ...prev,
            page: 1,
            pageSize: newPageSize === 'All' ? payoutReportState.shopifyPayoutTableRow : newPageSize
        }));
    }

    const onPageChange = (e) => {
        setFilter({ ...filter, page: e })
    }
 
    // whenever local filter inputs change update the query object that will be used to fetch
    useEffect(() => {
        setFilter(prev => ({
            ...prev,
            page: 1,
            start_date: isValidDate(startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
            end_date: isValidDate(endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
            gateway : gateway ? gateway.key : null,
            partner_id : partner ? partner?.id : null
        }));
    }, [startDate, endDate, gateway, partner]);
    
    // update URL whenever dateRange or gateway changes
    useEffect(() => {
        updateUrlParams({
            start_date: isValidDate(startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
            end_date: isValidDate(endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
            gateway: gateway ? gateway.key : null
        });
    }, [startDate, endDate, gateway]);

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: 50,
            border: "none"
        }),
    };

    const subTableColumns = [
        {
            name: 'Invoice Number',
            selector: row => row.invoice_number,
            left: true,
        },
        {
            name: 'Due Amount',
            selector: row => formatterCurrency(row.due_amount, row.currency),
            right: true,
        },
        {
            name: 'Amount',
            selector: row => formatterCurrency(row.amount, row.currency),
            right: true,
        },
        {
            name: 'Currency',
            selector: row => row.currency,
            center: true,
        },
        {
            name: 'Currency Rate',
            selector: row => formatterNumber(row.currency_rate, 6),
            center: true,
        },
        {
            name: 'Bank Amount',
            selector: row => formatterCurrency(row.bank_amount, row.source_currency),
            right: true,
        },
        {
            name: 'Status',
            selector: row => (
                <>
                    <span className={`badge badge-${row.status === 'Paid' ? 'success' : 'warning'}`}>
                        {row.status}
                    </span>
                    {row.error_message && row.error_message.length > 0 && (
                        <PopoverFormula className="text-danger ml-2" id={row.gateway + '_' + row.id + '_errorXeroPayment'}>
                            <PopoverBody>
                                {get(row, 'error_message', []).map((element, index) => (
                                    <p key={row.gateway + '_' + row.id + '_errorXeroPayment_' + index}>{get(element, 'Message', '')}</p>
                                ))}
                            </PopoverBody>
                        </PopoverFormula>
                    )}
                </>
            ),
            center: true,
        },
    ];

    const expandableComponent = ({ xeroPaymentItems }) => {
        let bankAmountTotal = 0;
        xeroPaymentItems.forEach(item => {
            bankAmountTotal += parseFloat(item.bank_amount);
        });

        const footerData = <tr className="bg-warning">
                <th className="font-weight-bold text-right" colSpan={5}>Total</th>
                <th className="font-weight-bold text-right">{formatterCurrency(bankAmountTotal, xeroPaymentItems.length > 0 ? xeroPaymentItems[0].source_currency : 'GBP')}</th>
                <th></th>
            </tr>;

        return (
            <BootstrapTable
                headerColumns={subTableColumns}
                gridData={[...xeroPaymentItems]}
                footerContent={footerData}
                noAction
                pagination={false}
                size="sm"
                perPage="All"
            />
        );
    };

    const [totalSTXRequests, setTotalSTXRequests] = useState(0);
    const [totalSTXRequestsCompleted, setTotalSTXRequestsCompleted] = useState(0);

    useEffect(() => {
        if (totalSTXRequests > 0 && totalSTXRequests === totalSTXRequestsCompleted) {
            // all requests completed, refresh data
            setTotalSTXRequests(0);
            setTotalSTXRequestsCompleted(0);
            setFilter({ ...filter, draw: filter.draw + 1 });
        }
    }, [totalSTXRequests, totalSTXRequestsCompleted]);

    return (
        <Fragment>
            <Breadcrumb title="Payments Sources" data={dataMenu} />
            <Container fluid={true} className="finances-summary-page feature-products">
                <Card className="px-3">
                    <Row className="d-flex items-align-center">
                        <Col md="4">
                            <div className="p-3">
                                <DateRangePickerPrimary
                                    dateRange={dateRange}
                                    dateRangeChange={(date) => {
                                        setDateRange(date);
                                    }}
                                    // only provide defaultValue when we have validated dates
                                    defaultValue={(isValidDate(startDateObj) || isValidDate(endDateObj)) ? [startDateObj, endDateObj] : undefined}
                                    disabledDate={afterToday()}
                                />
                            </div>
                        </Col>
                        <Col md="4 p-3">
                            <Select
                                className="select2-filter"
                                styles={customStyles}
                                placeholder="Filter by Gateway"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.key}
                                value={gateway}
                                onChange={(e) => {
                                   setGateway(e ? e : null);
                                }}
                                components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: (props) => {
                                        return gateway ? null : <components.DropdownIndicator {...props} />;
                                    }
                                }}
                                isClearable={true}
                                options={financesSummaryState.settings.gateways}
                            />
                        </Col>
                        <Col md="4 p-3">
                            <Select
                                className="select2-filter"
                                styles={customStyles}
                                placeholder="Filter by Partner"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={partner}
                                onChange={(e) => {
                                   setPartner(e ? e : null);
                                }}
                                components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: (props) => {
                                        return gateway ? null : <components.DropdownIndicator {...props} />;
                                    }
                                }}
                                isClearable={true}
                                options={financesSummaryState.settings.partners}
                            />
                        </Col>
                        {/* <Col md="4" className="d-flex align-items-center justify-content-end">
                            <div className="p-3">
                                <Link to="/report/xero-invoices" className="btn btn-primary btn-sm">
                                    View Xero Invoices
                                </Link>
                            </div>
                        </Col> */}
                    </Row>
                </Card>

                <Card className="px-3">
                    <CardBody>
                        <BootstrapTable
                            headerColumns={tableColumns}
                            gridData={payoutReportState.shopifyPayoutLists}
                            noAction
                            progressPending={loading}
                            paginationServer
                            paginationTotalRows={payoutReportState.shopifyPayoutTableRow}
                            currentPage={filter.page}
                            perPage={filter.pageSize}
                            onChangePage={onPageChange}
                            onChangeRowsPerPage={onPageSizeChange}
                            size="md"
                            expandableRows={true}
                            expandableRowsComponent={expandableComponent}
                            // expandOnRowClicked={true} // Optional: expand on row click
                            // expandableRowDisabled={(row) => row.disabled} // Optional: disable expansion for certain rows
                        />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
}

export default withReducer([{ report: reportReducer }])(ShopifyPayout);